import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import { AuthContext } from '../../../context';

import mutations from '../../../graphql/mutations';

import style from './index.module.scss';

const {
  userMutations: { FOLLOW_OR_UNFOLLOW_USER },
} = mutations;

function ProfileActions({ user, currentUser, action }) {
  // Check if profile belongs to current user
  const isCurrentUser = user.id === currentUser.id;

  // Check if current user is already following user
  const isFollowing = user.followers
    .map(follower => follower.id)
    .includes(currentUser.id);

  const handleFollow = async followOrUnfollowUser => {
    const res = await followOrUnfollowUser({
      variables: {
        input: {
          followerId: currentUser.id,
          userToFollowId: user.id,
          actionType: isFollowing ? 'unfollow' : 'follow',
        },
      },
    });

    console.log(res);
  };

  return (
    <>
      {!isCurrentUser && (
        <Mutation mutation={FOLLOW_OR_UNFOLLOW_USER}>
          {followOrUnfollowUser => (
            <span
              className={action}
              onClick={() => handleFollow(followOrUnfollowUser)}
            >
              <i className={`fas fa-user${isFollowing ? '' : '-plus'}`} /> Follow{isFollowing ? 'ing' : ''}
            </span>
          )}
        </Mutation>
      )}
      <span className={action}>
        <i className="fas fa-times" /> Notify Me
      </span>
      <span className={action}>
        <i className="fas fa-rss" /> Ask Question
      </span>
      <span className={action}>
        <i className="fas fa-rss" />
      </span>
    </>
  );
}

function ProfileHeader({ user }) {
  const { currentUser } = useContext(AuthContext);
  const {
    header,
    img,
    name,
    bio,
    description,
    actions,
    action,
  } = style;

  return (
    <header className={`row ${header}`}>
      <div className={`col ${style['col--img']}`}>
        <img
          src={user.imgUrl || "https://i.imgur.com/qHpJwKV.jpg"}
          alt={user.fullname}
          className={img}
        />
      </div>
      <div className={`col ${style['col--description']}`}>
        <h2 className={name}>
          <span>{user.fullname}</span>
          {user.isDeceased && (
            <span className={style['is-deceased']}>Deceased</span>
          )}
        </h2>
        <p className={bio}>{user.bio}</p>
        <p className={`${description} ${style['description--large']}`}>
          {user.description}
        </p>
        <div className={`${actions} ${style['actions--large']}`}>
          <ProfileActions
            user={user}
            currentUser={currentUser}
            action={action}
          />
        </div>
      </div>
      <p className={`${description} ${style['description--mobile']}`}>
        {user.description}
      </p>
      <div className={`${actions} ${style['actions--mobile']}`}>
        <ProfileActions user={user} currentUser={currentUser} action={action} />
      </div>
    </header>
  );
}

ProfileHeader.propTypes = {
  user: PropTypes.shape({
    fullname: PropTypes.string.isRequired,
    bio: PropTypes.string,
    imgUrl: PropTypes.string,
    description: PropTypes.string.isRequired,
  }).isRequired,
};

export default ProfileHeader;
